import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { filter } from 'rxjs';
import { RespondentTokenStorageService } from '@core/services/respondent-token-storage.service';
import { RespondentAccountMenuButtonComponent } from '../components/respondent-account-menu-button/respondent-account-menu-button';

@Component({
  selector: 'app-my-forms-layout',
  imports: [
    RespondentAccountMenuButtonComponent,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: './my-forms-layout.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyFormsLayoutComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly respondentTokenStorage = inject(RespondentTokenStorageService);

  readonly isAuthenticated = signal(false);

  ngOnInit(): void {
    this.refreshAuthState();

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.refreshAuthState());
  }

  private refreshAuthState(): void {
    this.isAuthenticated.set(this.respondentTokenStorage.isAuthenticated());
  }
}
